// ProjectInfo.jsx
import React, { useState, useEffect } from 'react';

function ProjectSpec({ title, type }) {
  const [spec, setSpec] = useState([]);
  
  useEffect(() => {
    fetch('/resources/projSpec.json')
      .then(response => {
        if (!response.ok) {
          throw new Error('네트워크 응답이 정상이 아닙니다.');
        }
        return response.json();
      })
      .then(data => setSpec(data))
      .catch(error => console.error('파싱 중 에러 발생:', error));
  }, []);

  return (
    <div className='projSpecSection'>
      <div className='spacer' />
      <div className='projSpec'>
        <div className='titleLabel'>
          <span>{title}</span>
        </div>
        <div className='space' />
        <div className='projSpecH5'>
          본 제품은 <strong>[의료기기]</strong>입니다.<br />
          임상시험용 외의 목적으로 사용할 수 없습니다.
        </div>
        <div className='space' />
        <table className="projectTableRoot">
          <tbody>
            {spec[type] && spec[type].map(({ header, value }, index) => (
              <tr key={index}>
                <td className="projTableHeaderSection">{header}</td>
                <td className="projTableValueSection">{value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <hr className='divider' />
      <div className='corpSpec'>
        <div className='corpSpecH5'>
          제조사 상호 : (주)디지털팜<br />
          대표자 : 김대진 | 사업자등록번호 : 647-87-02394 | 대표전화 : 02-533-0711<br />
          주소 : 서울특별시 서초구 반포대로 222, 옴니버스파크 연구동 3층 3201호, 3204호
        </div>
      </div>
      <div className='space' />
    </div>
  );
}

export default ProjectSpec;